import { useTranslation } from "react-i18next";
import { settingsService } from "src/services/settings.service";
import classes from "./Headers.module.scss";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
export default function Header(): JSX.Element {
  const { settings } = settingsService();

  const { t } = useTranslation();
 const loggedInMode=Cookies.get('loggedInMode')
 const agentPortalURL=loggedInMode =="Agent" && settings.agentPortalURL != null ?settings.agentPortalURL+"/PropertyList/Index":settings.agentPortalURL;
 const onlinePortalURL=loggedInMode =="Taxpayer" && settings.onlinePortalURL != null ?settings.onlinePortalURL+"/PropertyListing/Index":settings.onlinePortalURL;
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();  

   Cookies.set('propertyId','');
 
    window.open(agentPortalURL,'_self');
  }; 
 return (
    <div className={classes.Header}>
      <div>
        <div className={classes.SiteIcon}></div>
        <Link to="/" className={classes.SiteLink}>
          <span>{settings.clientName}</span>
          <span>{t("public.header.onlineForms")}</span>
        </Link>
      </div>

      
      
      <div className={classes.HeaderLinkWrapper}>
          {!settings.enableFormsOnlyLogin &&settings.agentPortalURL && (
          <a
            target="_blank"
            rel="noreferrer"
            href={agentPortalURL}
            className={classes.HeaderLinks}  
          >
            <div className={[classes.Icon, classes.OpIcon].join(" ")}></div>
            <div>{t("public.header.agentPortal")}</div>
          </a>
        )}
        {settings.enableFormsOnlyLogin && settings.linkCadAgentAppeal && (
            <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadAgentAppeal}
            className={classes.HeaderLinks}  
          >
            <div className={[classes.Icon, classes.OpIcon].join(" ")}></div>
            <div>{t("public.header.agentProtest")}</div>
          </a>
        )}
         {settings.enableFormsOnlyLogin && settings.linkCadTaxpayerAppeal && (
            <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadTaxpayerAppeal}
            className={classes.HeaderLinks} 
          >
            <div className={[classes.Icon, classes.OpIcon].join(" ")}></div>
            <div>{t("public.header.onlineAppeal")}</div>
          </a>
         )}
        {!settings.enableFormsOnlyLogin &&settings.linkCadOnlineProtest && (
          <a
            target="_blank"
            rel="noreferrer"
            href={onlinePortalURL}
            className={classes.HeaderLinks} 
          >
            <div className={[classes.Icon, classes.OpIcon].join(" ")}></div>
            <div>{t("public.header.onlinePortal")}</div>
          </a>
        )}

        {settings.linkCadPropertySearch && (
          <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadPropertySearch}
            className={classes.HeaderLinks}
          >
            <div className={[classes.Icon, classes.PsIcon].join(" ")}></div>
            <div>{t("public.header.propertySearch")}</div>
          </a>
        )}
        {settings.linkCadGisMap && (
          <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadGisMap}
            className={classes.HeaderLinks}
          >
            <div className={[classes.Icon, classes.MapIcon].join(" ")}></div>
            <div>{t("public.header.interactiveMap")}</div>
          </a>
        )}

        {settings.linkCadWebsite && (
          <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadWebsite}
            className={classes.HeaderLinks}
          >
            <div className={[classes.Icon, classes.Seal].join(" ")}></div>
            <div>{t("public.header.homepage")}</div>
          </a>
        )}

        <div className={classes.Home}>
          <a
            target="_blank"
            rel="noreferrer"
            href={settings.linkCadWebsite}
            className={classes.HomeLink}
          >
            {t("public.header.home")}
          </a>
        </div>
      </div>
    </div>
  );
}
